import { makeStyles } from '@material-ui/styles';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export default makeStyles(() => ({
  backdrop: {
    backgroundColor: 'rgba(0,0,0,0.3)',
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalPaper: {
    padding: 16,
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    maxHeight: '90%',
    overflowY: 'auto',
    maxWidth: 570,
    outline: 'none',
    borderRadius: 10,
  },
  modalHeader: {
    display: 'flex',
    flexDirection: 'row',
  },
  modalHeaderSides: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  modalHeaderCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 3,
  },
  modalHeaderClose: {
    justifyContent: 'flex-end',
  },
  modalHeaderBack: {
    width: '15px !important',
    height: 15,
  },
  menuProps: {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  },
  inputLabel: {
    fontSize: 12,
    marginTop: 15,
  },
}));
